import React, {memo, Suspense} from "react"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/header"
import connect from "./connect"

export type BrandProps = {
    narrowModeIcon: string
    wideModeIcon: string
    tooltip: string
    url: string
    accessibilityText: string
    tabbedNavigationEnabled: boolean
    isTabbedNavSetToDefault: boolean
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
}

const Brand = memo((props: BrandProps) => {
    const {mainTemplate, fallbackTemplate} = props.templating
    const ComponentName = useTemplatedComponent({mainTemplate, fallbackTemplate}, MANIFEST)

    return (
        <Suspense>
            <ComponentName {...props} />
        </Suspense>
    )
})
Brand.displayName = "Brand"

export default connect(Brand)
